/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import PermissionTypes, { selfServiceSessionLogPagePermissionsAny } from "./model/constants/permissionTypes";
import {
  isGranted
} from "./utils/auth";
import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'
import { PUBLIC_ROUTE_NAMES, hasValidToken, clearSession } from './utils/session'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('@/views/pages/Dashboard/Dashboard.vue'),
          meta: {
            rule: 'editor',
            permissions: [PermissionTypes.Permissions_Administrator]
          }
        },


        // =============================================================================
        // Application Routes
        // =============================================================================
        /*{
          path: '/apps/todo',
          redirect: '/apps/todo/all'
        },
        {
          path: '/apps/todo/:filter',
          name: 'todo',
          component: () => import('./views/apps/todo/Todo.vue'),
          meta: {
            rule: 'editor',
            parent: "todo"
          }
        },*/

        // =============================================================================
        // Pages Routes
        // =============================================================================
        {
          path: '/pages/roles',
          name: 'page-roles',
          component: () => import('@/views/pages/Role/Roles.vue'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
              {
                title: 'Roller',
                active: true
              },
            ],
            pageTitle: 'Roller Listesi',
            rule: 'editor'
          },
        },
        {
          path: '/pages/users',
          name: 'page-users',
          component: () => import('@/views/pages/User/Users.vue'),
          meta: {
            permissions: [PermissionTypes.user_read],
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
              {
                title: 'Kullanıcılar',
                active: true
              },
            ],
            pageTitle: 'Kullanıcılar Listesi',
            rule: 'editor'
          },
        },
        {
          path: '/pages/MonthlyStockTransfer',
          name: 'page-monthly-stock-transfer',
          component: () => import('@/views/pages/MonthlyStockTransfer/MonthlyStockTransfer.vue'),
          meta: {
            permissions: [PermissionTypes.stock_taking_create_read],
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
              {
                title: 'Stoklar',
                active: true
              },
            ],
            pageTitle: 'Ay Sonu Stok Sayımı ve Devir',
            rule: 'editor'
          },
        },
        {
          path: '/pages/Targets',
          name: 'page-targets',
          component: () => import('@/views/pages/Target/Targets.vue'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
              {
                title: 'Hedefler',
                active: true
              },
            ],
            pageTitle: 'Hedefler',
            rule: 'editor'
          },
        },
        {
          path: '/pages/Branchs',
          name: 'page-branchs',
          component: () => import('@/views/pages/Branch/Branchs.vue'),
          meta: {
            permissions: [PermissionTypes.branch_list_read],
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
              {
                title: 'Şubeler',
                active: true
              },
            ],
            pageTitle: 'Şubeler Listesi',
            rule: 'editor'
          },
        },
        {
          path: '/pages/BranchCatalogSync',
          name: 'page-BranchCatalogSync',
          component: () => import('@/views/pages/Branch/BranchCatalogSync.vue'),
          meta: {
            permissions: [PermissionTypes.branch_list_read],
            centerBranchOnly: true,
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
              {
                title: 'Şube Katalog Aktarımı',
                active: true
              },
            ],
            pageTitle: 'Şube Katalog Aktarımı',
            rule: 'editor'
          },
        },
        {
          path: '/pages/BranchsProductList',
          name: 'page-BranchsProductList',
          component: () => import('@/views/pages/Branch/BranchsProductList.vue'),
          meta: {
            permissions: [PermissionTypes.price_list_read],
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
              {
                title: 'Şubeler',
                active: true
              },
            ],
            pageTitle: 'Şubeler Fiyat Listesi',
            rule: 'editor'
          },
        },
        {
          path: '/pages/PriceLists',
          name: 'page-PriceLists',
          component: () => import('@/views/pages/Product/PriceLists.vue'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
              {
                title: 'Fiyat Listeleri',
                active: true
              },
            ],
            pageTitle: 'Fiyat Listeleri',
            rule: 'editor'
          },
        },
        {
          path: '/pages/StockOrder',
          name: 'page-stock-order',
          component: () => import('@/views/pages/StockOrder/StockOrders.vue'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
              {
                title: 'Stok Siparişleri',
                active: true
              },
            ],
            pageTitle: 'Stok Siparişleri',
            rule: 'editor',
            props: true
          },
        },
        {
          path: '/pages/suppliers',
          name: 'page-suppliers',
          component: () => import('@/views/pages/Supplier/Suppliers.vue'),
          meta: {
            permissions: [PermissionTypes.supplier],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Tedarikçiler',
                active: true
              },
            ],
            pageTitle: 'Tedarikçiler',
            rule: 'editor'
          },
        },
        {
          path: '/pages/products',
          name: 'page-products',
          component: () => import('@/views/pages/Product/Products.vue'),
          meta: {
            permissions: [PermissionTypes.product_list_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Ürünler',
              },
              {
                title: 'Ürün Listesi',
                active: true
              },
            ],
            pageTitle: 'Ürün Listesi',
            rule: 'editor'
          },
        },
        {
          path: "/pages/integrations",
          name: "page-integrations",
          component: () => import("@/views/pages/Integration/Integrations.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            centerBranchOnly: true,
            breadcrumb: [
              {
                title: "Home",
                url: "/",
              },
              {
                title: "Entegrasyonlar",
                active: true,
              },
            ],
            pageTitle: "Entegrasyonlar",
            rule: "editor",
            props: true,
          },
        },
        {
          path: "/pages/integration/:slug",
          name: "integration-detail",
          component: () =>
            import("@/views/pages/Integration/IntegrationDetail.vue"),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            centerBranchOnly: true,
            breadcrumb: [
              { title: "Anasayfa", url: "/" },
              { title: "Entegrasyonlar", url: "/pages/integrations" },
              { title: "Detay", active: true },
            ],
            pageTitle: "Entegrasyon Detayı",
            rule: "editor",
          },
        },
        {
          path: '/pages/productSizes',
          name: 'page-product-sizes',
          component: () => import('@/views/pages/ProductSize/ProductSizes.vue'),
          meta: {
            permissions: [PermissionTypes.cup_sizes_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Ürünler',
              },
              {
                title: 'Boy Listesi',
                active: true
              },
            ],
            pageTitle: 'Boy Listesi',
            rule: 'editor'
          },
        },
        {
          path: '/pages/productCategories',
          name: 'page-product-categories',
          component: () => import('@/views/pages/ProductCategory/ProductCategory.vue'),
          meta: {
            permissions: [PermissionTypes.product_category_list_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Ürünler',
              },
              {
                title: 'Ürün Kategori Listesi',
                active: true
              },
            ],
            pageTitle: 'Ürün Kategori Listesi',
            rule: 'editor'
          },
        },
        {
          path: '/pages/bills',
          name: 'page-bills',
          component: () => import('@/views/pages/Bill/Bills.vue'),
          meta: {
            permissions: [PermissionTypes.bill_read_create],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Stoklar',
              },
              {
                title: 'Faturalarım',
                active: true
              },
            ],
            pageTitle: 'Faturalarım',
            rule: 'editor'
          },
        },
        {
          path: '/pages/stocks',
          name: 'page-stocks',
          component: () => import('@/views/pages/Stock/Stocks.vue'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Ürünler',
              },
              {
                title: 'Stok Listesi',
                active: true
              },
            ],
            pageTitle: 'Stok Listesi',
            rule: 'editor'
          },
        },
        {
          path: '/pages/units',
          name: 'page-units',
          component: () => import('@/views/pages/Unit/Units.vue'),
          meta: {
            permissions: [PermissionTypes.unit_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Birimler',
              },
              {
                title: 'Birim Listesi',
                active: true
              },
            ],
            pageTitle: 'Birim Listesi',
            rule: 'editor'
          },
        },
        {
          path: '/pages/rawMaterials',
          name: 'page-raw-materials',
          component: () => import('@/views/pages/RawMaterial/RawMaterials.vue'),
          meta: {
            permissions: [PermissionTypes.rawmaterial_list_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Ürünler',
              },
              {
                title: 'Hammaddeler',
                active: true
              },
            ],
            pageTitle: 'Hammaddeler',
            rule: 'editor'
          },
        },
        {
          path: '/pages/rawMaterialCategories',
          name: 'page-raw-material-categories',
          component: () => import('@/views/pages/RawMaterialCategory/RawMaterialCategories'),
          meta: {
            permissions: [PermissionTypes.rawmaterial_category_list_read],
            centerBranchOnly: true,
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Ürünler',
              },
              {
                title: 'Hammadde Kategorileri',
                active: true
              },
            ],
            pageTitle: 'Hammaddeler Kategorileri',
            rule: 'editor'
          },
        },
        {
          path: '/pages/halfMadeProducts',
          name: 'page-half-made-products',
          component: () => import('@/views/pages/HalfMadeProduct/HalfMadeProducts.vue'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Ürünler',
              },
              {
                title: 'Yarı Mamüller',
                active: true
              },
            ],
            pageTitle: 'Yarı Mamüller',
            rule: 'editor'
          },
        },
        {
          path: '/pages/campaign',
          name: 'page-campaign',
          component: () => import('@/views/pages/Campaign/Campaigns.vue'),
          meta: {
            permissions: [PermissionTypes.campaign_read, PermissionTypes.campaign_write, PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Kampanyalar',
                active: true
              }
            ],
            pageTitle: 'Kampanyalar',
            rule: 'editor'
          },
        },
        {
          path: '/pages/partner-campaign-qr',
          name: 'page-partner-campaign-qr',
          component: () => import('@/views/pages/Campaign/PartnerCampaignQr.vue'),
          meta: {
            permissions: [PermissionTypes.campaign_read],
            centerBranchOnly: true,
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Partner QR',
                active: true
              }
            ],
            pageTitle: 'Partner QR Kampanyaları',
            rule: 'editor'
          },
        },
        {
          path: '/pages/documents',
          name: 'page-documents',
          component: () => import('@/views/pages/Document/Documents.vue'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Dökümanlar',
                active: true
              }
            ],
            pageTitle: 'Dökümanlar',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/BranchComparativeReport',
          name: 'page-branch-comparative-report',
          component: () => import('@/views/pages/Reports/ComparativeReport/ComparativeBranchReport'),
          meta: {
            permissions: [PermissionTypes.branch_comparison_report],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Şube Karşılaştırma',
                active: true
              }
            ],
            pageTitle: 'Şube Karşılaştırma',
            rule: 'editor'
          },
        },
        {
          path: '/pages/draws',
          name: 'page-draw',
          component: () => import('@/views/pages/Draw/Draws.vue'),
          meta: {
            permissions: [PermissionTypes.draw_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Çekilişler',
                active: true
              }
            ],
            pageTitle: 'Çekilişler',
            rule: 'editor'
          },
        },
        {
          path: '/pages/CustomerTickets',
          name: 'page-customer-tickets',
          component: () => import('@/views/pages/Draw/CustomerTickets'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Kullanıcı Biletleri',
                active: true
              }
            ],
            pageTitle: 'Kullanıcı Biletleri',
            rule: 'editor'
          },
        },
        {
          path: '/pages/recipes',
          name: 'page-recipes',
          component: () => import('@/views/pages/Recipe/Recipes.vue'),
          meta: {
            permissions: [PermissionTypes.receipt_list_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Ürünler',
              },
              {
                title: 'Reçeteler',
                active: true
              },
            ],
            pageTitle: 'Reçeteler',
            rule: 'editor'
          },
        },
        {
          path: '/pages/distributors',
          name: 'page-distributors',
          component: () => import('@/views/pages/Distributor/Distributors.vue'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Tedarikçiler',
              },
              {
                title: 'Distribütörler',
                active: true
              },
            ],
            pageTitle: 'Distribütörler',
            rule: 'editor'
          },
        },
        {
          path: '/pages/orderLogs',
          name: 'page-order-logs',
          component: () => import('@/views/pages/OrderLog/OrderLog/OrderLogs.vue'),
          meta: {
            permissions: [PermissionTypes.hot_sale_record_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Sıcak Satış Kayıtlar',
                active: true
              },
            ],
            pageTitle: 'Sıcak Satış Kayıtları',
            rule: 'editor'
          },
        },
        {
          path: '/pages/selfServiceSessionLog',
          name: 'page-self-service-session-log',
          component: () => import('@/views/pages/Reports/SelfServiceSessionLog/SelfServiceSessionLogReport.vue'),
          meta: {
            permissions: selfServiceSessionLogPagePermissionsAny,
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
                url: '#'
              },
              {
                title: 'Personel İşlem Raporu',
                active: true
              },
            ],
            pageTitle: 'Personel İşlem Raporu',
            rule: 'editor'
          },
        },
        {
          // Yalnızca süper admin: backend [SuperAdmin] ile ayrıca korunur, sayfa da kendi içinde kontrol eder.
          path: '/pages/selfServiceDiagnosticLog',
          name: 'page-self-service-diagnostic-log',
          component: () => import('@/views/pages/Reports/SelfServiceSessionLog/SelfServiceDiagnosticLog.vue'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
                url: '#'
              },
              {
                title: 'Kasa Teşhis Günlüğü',
                active: true
              },
            ],
            pageTitle: 'Kasa Teşhis Günlüğü',
            rule: 'editor'
          },
        },
        {
          path: '/pages/expenseDefinitions',
          name: 'page-expense-definitions',
          component: () => import('@/views/pages/ExpenseDefinition/ExpenseDefinitions.vue'),
          meta: {
            permissions: [PermissionTypes.expense_type],
            centerBranchOnly: true,
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Gider Tipleri',
              },
              {
                title: 'Gider Tipleri',
                active: true
              },
            ],
            pageTitle: 'Gider Tipleri',
            rule: 'editor'
          },
        },
        {
          path: '/pages/blackLists',
          name: 'page-black-lists',
          component: () => import('@/views/pages/BlackList/BlackLists.vue'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            centerBranchOnly: true,
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Yasaklı Kullanıcılar',
              },
              {
                title: 'Yasaklı Kullanıcılar',
                active: true
              },
            ],
            pageTitle: 'Yasaklı Kullanıcılar',
            rule: 'editor'
          },
        },
        {
          path: '/pages/userwant',
          name: 'userwant',
          component: () => import('@/views/pages/UserWants/UserWant.vue'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Kullanıcı İstekleri',
              },
              {
                title: 'Kullanıcı İstekleri',
                active: true
              },
            ],
            pageTitle: 'Kullanıcı İstekleri',
            rule: 'editor'
          },
        },
        {
          path: '/pages/userwantcategory',
          name: 'userwantcategory',
          component: () => import('@/views/pages/UserWantCategory/UserWantCategory.vue'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'BM İletişim Sistemi',
              },
              {
                title: 'Kategori Yönetimi',
                active: true
              },
            ],
            pageTitle: 'Kategori Yönetimi',
            rule: 'editor'
          },
        },
        {
          path: '/pages/roles',
          name: 'page-role-lists',
          component: () => import('@/views/pages/Role/Roles.vue'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Roller',
              },
              {
                title: 'Roller',
                active: true
              },
            ],
            pageTitle: 'Roller',
            rule: 'editor'
          },
        },
        {
          path: '/pages/CisTable',
          name: 'CisTable',
          component: () => import('@/views/pages/Cis/CisTableView.vue'),
          meta: {
            rule: 'editor',
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
            {
              title: 'Çalışan İletişim Sistemi',
            },
            {
              title: 'Tablo Görünümü',
              active: true
            }],
            pageTitle: 'İstekler Tablosu'
          }
        },
        {
          path: '/pages/losses',
          name: 'page-losses',
          component: () => import('@/views/pages/Loss/Losses.vue'),
          meta: {
            permissions: [PermissionTypes.loss_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Zayiat',
              },
              {
                title: 'Zayiatlar',
                active: true
              },
            ],
            pageTitle: 'Zayiatlar',
            rule: 'editor'
          },
        },
        {
          path: '/pages/loss-deletion',
          name: 'page-loss-deletion',
          component: () => import('@/views/pages/Loss/LossDeletion.vue'),
          meta: {
            permissions: [PermissionTypes.loss_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Zayiat',
              },
              {
                title: 'Zayiat Silme',
                active: true
              },
            ],
            pageTitle: 'Zayiat Silme',
            rule: 'editor'
          },
        },
        {
          path: '/pages/lossReasons',
          name: 'page-loss-reasons',
          component: () => import('@/views/pages/LossReason/LossReasons.vue'),
          meta: {
            permissions: [PermissionTypes.loss_reason_read],
            centerBranchOnly: true,
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Zayiat',
              },
              {
                title: 'Zayiat Sebepleri',
                active: true
              },
            ],
            pageTitle: 'Zayiat Sebepleri',
            rule: 'editor'
          },
        },
        {
          path: '/pages/totalOrderLogs',
          name: 'page-total-order-logs',
          component: () => import('@/views/pages/OrderLog/TotalOrderLogs/TotalOrderLogs.vue'),
          meta: {
            permissions: [PermissionTypes.total_giro_report_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Sıcak Satış Kayıtları',
              },
              {
                title: 'Toplam Ciro Raporu',
                active: true
              },
            ],
            pageTitle: 'Toplam Ciro Raporu',
            rule: 'editor'
          },
        },
        {
          path: '/pages/expenses',
          name: 'page-expenses',
          component: () => import('@/views/pages/Expense/Expenses.vue'),
          meta: {
            permissions: [PermissionTypes.expense_read_write],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Sıcak Satış Kayıtları',
              },
              {
                title: 'Giderlerim',
                active: true
              },
            ],
            pageTitle: 'Giderlerim',
            rule: 'editor'
          },
        },
        {
          path: '/pages/discount',
          name: 'page-discount',
          component: () => import('@/views/pages/Discount/Discount.vue'),
          meta: {
            permissions: [PermissionTypes.discount_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Sıcak Satış Kayıtları',
              },
              {
                title: 'İndirimler/İkramlar',
                active: true
              },
            ],
            pageTitle: 'İndirimler/İkramlar',
            rule: 'editor'
          },
        },
        {
          path: '/pages/discountReason',
          name: 'page-discount-reason',
          component: () => import('@/views/pages/Discount/DiscountReason.vue'),
          meta: {
            permissions: [PermissionTypes.discount_reasons_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Sıcak Satış Kayıtları',
              },
              {
                title: 'İndirimler',
                active: true
              },
            ],
            pageTitle: 'İndirim Sebepleri',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/branch-report',
          name: 'page-branch-report',
          component: () => import('@/views/pages/Reports/BranchOrPersonalGiro/BranchOrPersonalGiro.vue'),
          meta: {
            permissions: [PermissionTypes.branch_giro_report_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Şube Raporu',
                active: true
              },
            ],
            pageTitle: 'Şube Raporu',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/category-report',
          name: 'page-category-report',
          component: () => import('@/views/pages/Reports/CategoryGiro/CategoryGiro.vue'),
          meta: {
            permissions: [PermissionTypes.category_report_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Kategori Ciro Raporu',
                active: true
              },
            ],
            pageTitle: 'Kategori Ciro Raporu',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/product-report',
          name: 'page-product-report',
          component: () => import('@/views/pages/Reports/ProductGiro/ProductGiro.vue'),
          meta: {
            permissions: [PermissionTypes.product_giro_report_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Ürün Ciro Raporu',
                active: true
              },
            ],
            pageTitle: 'Ürün Ciro Raporu',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/giro-by-time',
          name: 'page-giro-by-time',
          component: () => import('@/views/pages/Reports/GiroByTime/GiroByTime.vue'),
          meta: {
            permissions: [PermissionTypes.time_giro_report_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Zamana Göre Ciro Raporu',
                active: true
              },
            ],
            pageTitle: 'Zamana Göre Ciro Raporu',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/giro-by-date',
          name: 'page-giro-by-date',
          component: () => import('@/views/pages/Reports/GiroByDate/GiroByDate.vue'),
          meta: {
            permissions: [PermissionTypes.date_giro_report_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Tarihe Göre Ciro Raporu',
                active: true
              },
            ],
            pageTitle: 'Tarihe Göre Ciro Raporu',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/raw-material-consumption',
          name: 'raw-material-consumption',
          component: () => import('@/views/pages/Reports/RawMaterialConsumption/RawMaterialConsumption.vue'),
          meta: {
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
            {
              title: 'Raporlar',
              url: '#'
            },
            {
              title: 'Hammadde Tüketim Raporu',
              active: true
            }
            ],
            pageTitle: 'Hammadde Tüketim Raporu',
            rule: 'editor',
            permissions: ["rawmaterial_consume_report_read"]
          }
        },
        {
          path: '/pages/reports/raw-material-consumption-loss',
          name: 'raw-material-consumption-loss',
          component: () => import('@/views/pages/Reports/RawMaterialConsumptionLoss/RawMaterialConsumptionLoss.vue'),
          meta: {
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
            {
              title: 'Raporlar',
              url: '#'
            },
            {
              title: 'Zaiyat Hammadde Tüketim Raporu',
              active: true
            }
            ],
            pageTitle: 'Zaiyat Hammadde Tüketim Raporu',
            rule: 'editor',
            permissions: ["rawmaterial_consume_report_read"]
          }
        },
        {
          path: '/pages/reports/wallet-transaction',
          name: 'wallet-transaction',
          component: () => import('@/views/pages/Reports/WalletTransaction/WalletTransactionReport.vue'),
          meta: {
            permissions: [PermissionTypes.wallet_consume_report_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Cüzdan Raporu',
                active: true
              },
            ],
            pageTitle: 'Cüzdan Raporu',
            rule: 'editor'
          },
        },
        {
          path: '/pages/wallet/manual-topup',
          name: 'wallet-manual-topup',
          component: () => import('@/views/pages/Wallet/ManualWalletTopup.vue'),
          meta: {
            permissions: [PermissionTypes.wallet_manual_topup],
            centerBranchOnly: true,
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Mobil Uygulama',
              },
              {
                title: 'Manuel Cüzdan Yükleme ve Silme',
                active: true
              },
            ],
            pageTitle: 'Manuel Cüzdan Yükleme ve Silme',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/day-report',
          name: 'day-report',
          component: () => import('@/views/pages/Reports/DayReports/DayReport.vue'),
          meta: {
            permissions: [PermissionTypes.day_report_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Gün Sonu Raporu',
                active: true
              },
            ],
            pageTitle: 'Gün Sonu Raporu',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/wallet-offset',
          name: 'wallet-offset',
          component: () => import('@/views/pages/Reports/WalletOfSetting/WalletOfSettingReport.vue'),
          meta: {
            permissions: [PermissionTypes.wallet_offset_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Şube Mahsuplaşma',
                active: true
              },
            ],
            pageTitle: 'Şube Mahsuplaşma',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/wallet-accouting-report',
          name: 'wallet-offaccounting',
          component: () => import('@/views/pages/Reports/WalletOfSetting/WalletAccountingReport.vue'),
          meta: {
            permissions: [PermissionTypes.wallet_accounting_report],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Cüzdan Muhasebe Raporu',
                active: true
              },
            ],
            pageTitle: 'Cüzdan Muhasebe Raporu',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/customer-mood-report',
          name: 'customer-mood-report',
          component: () => import('@/views/pages/Reports/MoodReports/CustomerMoodReport'),
          meta: {
            permissions: [PermissionTypes.mood_report_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Kullanıcı Mood Raporu',
                active: true
              },
            ],
            pageTitle: 'Kullanıcı Mood Raporu',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/branch-balance-report',
          name: 'branch-balance-report',
          component: () => import('@/views/pages/Reports/MoodReports/BranchBalanceReport'),
          meta: {
            permissions: [PermissionTypes.mood_report_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Şube Bakiye Raporu',
                active: true
              },
            ],
            pageTitle: 'Şube Bakiye Raporu',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/customer-mood-report-new',
          name: 'customer-mood-report-new',
          component: () => import('@/views/pages/Reports/MoodReports/CustomerMoodReportNew'),
          meta: {
            permissions: [PermissionTypes.mood_report_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Kullanıcı Mood Raporu (Yeni)',
                active: true
              },
            ],
            pageTitle: 'Kullanıcı Mood Raporu (Yeni)',
            rule: 'editor'
          },
        },
        {
          path: '/pages/reports/branch-balance-report-new',
          name: 'branch-balance-report-new',
          component: () => import('@/views/pages/Reports/MoodReports/BranchBalanceReportNew'),
          meta: {
            permissions: [PermissionTypes.mood_report_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Şube Bakiye Raporu (Yeni)',
                active: true
              },
            ],
            pageTitle: 'Şube Bakiye Raporu (Yeni)',
            rule: 'editor'
          },
        },
        /* {
          path: '/pages/reports/campaign-gift-report',
          name: 'campaign-gift-report',
          component: () => import('@/views/pages/Reports/CampaignGift/CampaignGiftReport'),
          meta: {
            permissions: [PermissionTypes.campaign_gift_report],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Kampanya Hediye Raporu',
                active: true
              },
            ],
            pageTitle: 'Kampanya Hediye Raporu',
            rule: 'editor'
          },
        }, */
        {
          path: '/pages/reports/inventory-report',
          name: 'page-inventory-report',
          component: () => import('@/views/pages/Reports/InventoryReport/InventoryReport.vue'),
          meta: {
            permissions: [PermissionTypes.envanter_report_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Raporlar',
              },
              {
                title: 'Envanter Raporu',
                active: true
              },
            ],
            pageTitle: 'Envanter Raporu',
            rule: 'editor'
          },
        },
        {
          path: '/pages/payment-methods',
          name: 'page-payment-methods',
          component: () => import('@/views/pages/PaymentMethod/PaymentMethods.vue'),
          meta: {
            permissions: [PermissionTypes.payment_type],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Ödeme Tipi',
              },
              {
                title: 'Ödeme Tipleri',
                active: true
              },
            ],
            pageTitle: 'Ödeme Tipleri',
            rule: 'editor'
          },
        },
        {
          path: '/pages/ProductExtras',
          name: 'page-product-extras',
          component: () => import('@/views/pages/ProductExtra/ProductExtras.vue'),
          meta: {
            permissions: [PermissionTypes.extra_list_read],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Ürünler',
              },
              {
                title: 'Ekstralar',
                active: true
              },
            ],
            pageTitle: 'Ekstralar',
            rule: 'editor'
          },
        },
        {
          path: '/pages/stock-transfer-blocker',
          name: 'page-stock-transfer-blocker',
          component: () => import('@/views/pages/StockTransferBlocker'),
          meta: {
            permissions: [PermissionTypes.Permissions_Administrator],
            rule: 'editor'
          }
        },
        {
          path: '/pages/moodfelek-settings',
          name: 'page-moodfelek-settings',
          component: () => import('@/views/pages/Settings/MoodFelekSettings.vue'),
          meta: {
            permissions: [PermissionTypes.mood_felek_settings],
            centerBranchOnly: true,
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Ayarlar',
              },
              {
                title: 'Moodfelek Ayarları',
                active: true
              },
            ],
            pageTitle: 'Moodfelek Ayarları',
            rule: 'editor'
          },
        },
        {
          path: '/pages/app-settings',
          name: 'page-app-settings',
          component: () => import('@/views/pages/Settings/AppSettings'),
          meta: {
            permissions: [PermissionTypes.panel_settings],
            centerBranchOnly: true,
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Ayarlar',
              },
              {
                title: 'Panel Ayarları',
                active: true
              },
            ],
            pageTitle: 'Panel Ayarları',
            rule: 'editor'
          },
        },
        {
          path: '/pages/MoodImage',
          name: 'page-mood-image',
          component: () => import('@/views/pages/MoodProfileImages/MoodProfileImage'),
          meta: {
            permissions: [PermissionTypes.mood_image_settings],
            centerBranchOnly: true,
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Ayarlar',
              },
              {
                title: 'Mood Resim Ayarları',
                active: true
              },
            ],
            pageTitle: 'Mood Resim Ayarları',
            rule: 'admin'
          },
        },
        // {
        //   path: '/pages/mobile-settings',
        //   name: 'page-mobile-settings',
        //   component: () => import('@/views/pages/Settings/MobileSettings'),
        //   meta: {
        //     permissions: [PermissionTypes.Permissions_Administrator],
        //     breadcrumb: [{
        //       title: 'Anasayfa',
        //       url: '/'
        //     },
        //       {
        //         title: 'Ayarlar',
        //       },
        //       {
        //         title: 'Mobil Ayarları',
        //         active: true
        //       },
        //     ],
        //     pageTitle: 'Mobil Ayarları',
        //     rule: 'editor'
        //   },
        // },
        {
          path: '/pages/pos-settings',
          name: 'page-pos-settings',
          component: () => import('@/views/pages/Settings/PosSettings'),
          meta: {
            permissions: [PermissionTypes.pos_settings],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Pos Ayarları',
                active: true
              },
            ],
            pageTitle: 'Pos Ayarları',
            rule: 'editor'
          },
        },
        {
          path: '/pages/all-pos-settings',
          name: 'page-all-pos-settings',
          component: () => import('@/views/pages/Settings/AllPosSettings'),
          meta: {
            permissions: [PermissionTypes.pos_settings],
            centerBranchOnly: true,
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Pos Ayarları',
                active: true
              },
            ],
            pageTitle: 'Pos Ayarları',
            rule: 'editor'
          },
        },
        // =============================================================================
        // CHARTS & MAPS
        // =============================================================================
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/selfservice',
          name: 'page-self-service',
          component: () => import('@/views/pages/SelfService/SelfService.vue'),
          meta: {
            //notPermissions: [PermissionTypes.Permissions_Administrator],
            permissions: [PermissionTypes.sale_screen],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Satış Ekranı',
              },
              {
                title: 'Satış Ekranı',
                active: true
              },
            ],
            pageTitle: 'Satış Ekranı',
            rule: 'editor'
          },
        },
        {
          path: '/pages/bis-login',
          name: 'bis-login',
          component: () => import('@/views/pages/Login/BisLogin.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/document-login',
          name: 'document-login',
          component: () => import('@/views/pages/Login/DocumentLogin.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/MobileOrder',
          name: 'page-MobileOrder',
          component: () => import('@/views/pages/SelfService/MobileOrder.vue'),
          meta: {
            //permissions: [PermissionTypes.Permissions_Administrator],
            breadcrumb: [{
              title: 'Home',
              url: '/'
            },
              {
                title: 'MobileOrder',
                active: true
              },
            ],
            pageTitle: 'MobileOrder',
            rule: 'editor'
          },
        },
        {
          path: '/pages/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/Login/ForgotPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/Login/ResetPassword.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/customer-screen',
          name: 'CustomerScreen',
          component: () => import('@/views/pages/SelfService/CustomerScreen.vue'),
          meta: {
            rule: 'editor',
            title: 'Lütfen sayfanın herhangi bir yerine tıklayınız...',
          }
        },
        {
          path: '/pages/documents-only',
          name: 'page-documents-only',
          component: () => import('@/views/pages/Document/Documents.vue'),
          meta: {
            permissions: [PermissionTypes.sale_screen],
            breadcrumb: [{
              title: 'Anasayfa',
              url: '/'
            },
              {
                title: 'Dökümanlar',
                active: true
              }
            ],
            pageTitle: 'Dökümanlar',
            rule: 'editor'
          },
        },
        {
          path: '/pages/Cis',
          name: 'Cis',
          component: () => import('@/views/pages/Cis/Cis.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-500',
          name: 'page-error-500',
          component: () => import('@/views/pages/Error500.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/not-authorized',
          name: 'page-not-authorized',
          component: () => import('@/views/pages/NotAuthorized.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/maintenance',
          name: 'page-maintenance',
          component: () => import('@/views/pages/Maintenance.vue'),
          meta: {
            rule: 'editor'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})
function isMainCenterBranchUser() {
  const u = store.getters.getActiveUser;
  if (!u || !u.branch) return false;
  const isAdmin = u.rols === "admin";
  const isCenterBranch = u.branch.isCenter === true || u.branch.id === parseInt(process.env.VUE_APP_CENTER_BRANCH_ID, 10);
  if (isAdmin && isCenterBranch) return true;
  return u.branch.id === parseInt(process.env.VUE_APP_CENTER_BRANCH_ID, 10);
}

let beforeRouting = {
  to: null,
  from: null
};
/** Yetki kontrolü: reddedilirse yönlendirilecek yer, izin varsa null. */
function deniedRedirect(to) {
  const loginRedirect = { path: '/pages/login', query: { to: to.path } };
  if (to.matched.some(record => record.meta.permissions)) {
    const required = to.meta.permissions || [];
    if (!required.some(item => isGranted(item))) return loginRedirect;
  }
  if (to.matched.some(record => record.meta.notPermissions)) {
    const forbidden = to.meta.notPermissions || [];
    if (forbidden.some(item => isGranted(item))) return loginRedirect;
  }
  return null;
}

router.beforeEach((to, from, next) => {
  // Giriş zorunluluğu: herkese açık sayfalar dışında geçerli (süresi dolmamış) token şart.
  // Önceden token hiç kontrol edilmiyordu; çıkıştan sonra tarayıcıda kalan yetki listesiyle sayfalar açılabiliyordu.
  if (!PUBLIC_ROUTE_NAMES.includes(to.name) && !hasValidToken()) {
    clearSession({ keepCart: true });
    next({
      path: '/pages/login',
      query: to.fullPath && to.fullPath !== '/' ? { to: to.fullPath } : {},
      replace: true
    });
    return;
  }
  if (((from.name === 'page-stock-transfer-blocker' && to.name !== 'page-login') || (to === beforeRouting.to && from === beforeRouting.from)) && store.getters.getNeedStockTransfer) return;
  if (to.matched.some(record => record.meta.centerBranchOnly) && !isMainCenterBranchUser()) {
    next({ path: '/' });
    return;
  }
  const finish = () => {
    const denied = deniedRedirect(to);
    if (denied) {
      next(denied);
      return;
    }
    beforeRouting.to = to;
    beforeRouting.from = from ? from : to;
    next();
  };
  if ((to.name === from.name ? to.name !== "page-stock-transfer-blocker" : true) && ((to.name === "page-stock-transfer-blocker" && from.name === "page-self-service") || (to.name !== "page-login" && to.name !== "page-stock-transfer-blocker"))) {
    store.dispatch("setNeedStockTransfer").then(() => {
      if (store.getters.getNeedStockTransfer) {
        router.push({
          path: '/pages/stock-transfer-blocker',
          query: {
            to: to.path
          }
        })
      } else {
        finish();
      }
    });
  } else {
    finish();
  }
});
export default router
